var LocalAPIOverrideStorageKey = 'LOCAL_API_OVERRIDE';
var getAPIUrl = function () {
    var hostname = window.location.hostname;
    switch (hostname) {
        case 'turn2me.ie':
            return 'https://turn2me-api-production-htroeoozwa-ew.a.run.app';
        case 'wp.turn2me.ie':
            return 'https://turn2me-api-production-htroeoozwa-ew.a.run.app';
        case 'preflight.turn2me.ie':
            return 'https://turn2me-api-production-htroeoozwa-ew.a.run.app';
        case 'app.turn2me.ie':
            return 'https://turn2me-api-production-htroeoozwa-ew.a.run.app';
        case 'turn2me-v2.test':
        case 'localhost':
            // return 'https://turn2me-api-production-htroeoozwa-ew.a.run.app';
            return 'https://turn2me-api-v2.test';
        // return 'https://turn2me-api-htroeoozwa-ew.a.run.app';
        // return localStorage.getItem(LocalAPIOverrideStorageKey) ?? 'https://turn2me-v2-api.eu.ngrok.io';
        default:
            return 'https://turn2me-api-v2.test';
    }
};
export var API_URL = getAPIUrl().replace(/\/+$/, "") + "/api";
